import CertsSidePanelBodyError from './CertsSidePanelBodyError';

export default CertsSidePanelBodyError;
